import { useQuery } from "react-query";
import { useApplicationContext } from "src/hooks/useApplication";
import { getGraphConfiguration } from "pages/api-clients/graph-search";
import { useQueryToasterErrors } from "src/hooks/useToaster";

export function useIntegrationConfig() {
  const orgId = useApplicationContext().org_id!;
  const query = useQuery(
    ["graph-configuration", orgId],
    async () => getGraphConfiguration(orgId),
    { staleTime: Number.POSITIVE_INFINITY }
  );
  useQueryToasterErrors(query);

  return { query, data: query.data?.data || {} };
}
